import gql from 'graphql-tag';

export const fieldsQuery = gql`
  query DocumentFields($documentId: String!) {
    document(documentId: $documentId) {
      id
      pages {
        id
        fields {
          id
          pageId
          fieldType
          fieldLabel
          fieldValue
          fieldTop
          fieldLeft
          fieldWidth
          fieldHeight
          createdAt
          isCollectable
          isEditable
          isRequired
          validationRegex
          validationWarning
          fieldOptions
          recipientId
          documentId
          signatureBiometric
        }
      }
    }
  }
`;
